import React from "react";

// components
import Img from "components/Img";

export const Banner: React.FC = () => {
  return (
    <div className="s1__content-top--right relative">
      <Img
        name="img1S1"
        alt="Image molecule"
        className="s1__img-1 display-flex-table"
      />

      <div className="image display-none-table">
        <Img
          alt="CircleBluer1"
          name="circleBluer1"
          className="s1__CircleBluer1"
        />
        <Img
          alt="img4"
          name="line4"
          className="s1__line4"
        />
        <Img
          alt="CircleBluer2"
          name="circleBluer2"
          className="s1__CircleBluer2"
        />

        <Img
          alt="img1"
          name="line1"
          className="s1__line1"
        />
        <Img
          alt="EnamineLogo"
          name="enamineLogo"
          className="s1__EnamineLogo"
        />
        <Img
          alt="img2"
          name="line2"
          className="s1__line2"
        />
        <Img
          alt="img3"
          name="line3"
          className="s1__line3"
        />
        <Img
          alt="CircleBluer"
          name="circleBluer"
          className="s1__CircleBluer"
        />
        <Img
          alt="CircleBluer3"
          name="circleBluer3"
          className="s1__CircleBluer3"
        />
        <Img
          name="ebcLogo"
          alt="CircleBluer3"
          className="s1__EBCLogo"
        />
      </div>
    </div>
  );
};

export default Banner;
